import { useRouter } from 'next/router';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import parkplusStoreV2RedirectionRoutes from '../../../constants/parkplusStoreV2RedirectionRoutes';
import { LayoutPropType } from '../../../types/layout';
import ProductCard from '../../Cards/ProductCard';
import s from './CenteredCardListing.module.scss';
import Icon from 'ui-v2/components/Icon/Icon';
import { Typography } from 'ui-v2/components/Typography';
import dynamic from 'next/dynamic';

const Swiper = dynamic(() => import('core-lib/components/Swiper'), {
  ssr: false,
});

export const CenteredCardListing = ({ data }: LayoutPropType) => {
  const router = useRouter();

  return (
    <div className={s.root}>
      <div className={s.container}>
        <AnimatedImage
          src={data?.metaData?.headingImage}
          className={s.icon}
          alt="headingImage"
        />
        <Typography label={data?.title} variant="h_1_bold" />
        <Typography label={data?.subtitle} variant="body_3_regular" />
        <div className={s.carousel}>
          <Swiper
            effect="creative"
            creativeEffect={{
              prev: {
                translate: ['-100%', 0, 0],
                scale: 0.9,
              },
              next: {
                translate: ['100%', 0, 0],
                scale: 0.9,
              },
            }}
            slidesPerView={1.8}
            centeredSlides
            spaceBetween={10}
            loop={true}
            slides={data?.data
              ?.filter((item) => item?.stock > 0)
              .map((item, id) => (
                <div
                  key={item?.productSku}
                  onClick={() => {
                    router.push(
                      `${parkplusStoreV2RedirectionRoutes.instantPetrol}`
                    );
                  }}
                >
                  <ProductCard product={item} section={data?.title} />
                </div>
              ))}
          />
        </div>
      </div>
      <div
        className={s.strip}
        onClick={() => {
          router.push(`${parkplusStoreV2RedirectionRoutes.instantPetrol}`);
        }}
      >
        <Typography
          label="Unlock now"
          variant="body_3_medium"
          color="on_dark_bg"
        />
        <Icon name="RoundRightArrowCircleRegular"
          width={20}
          height={20}
          color="on_dark_bg"
        />
      </div>
    </div>
  );
};
